import { render, staticRenderFns } from "./AddVirtual.vue?vue&type=template&id=2c1f4617&scoped=true"
import script from "./AddVirtual.vue?vue&type=script&lang=js"
export * from "./AddVirtual.vue?vue&type=script&lang=js"
import style0 from "./AddVirtual.vue?vue&type=style&index=0&id=2c1f4617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f4617",
  null
  
)

export default component.exports